import React, { useState } from 'react';
import { FaComment, FaPhone, FaEnvelope, FaWhatsapp } from 'react-icons/fa';
import './FloatingActionButton.css';

const FloatingActionButton = ({ translations }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleFabMenu = () => {
    setIsOpen(!isOpen);
  };

  // Get contact information from translations
  const contactTranslations = translations?.components?.contact?.translations || {};
  const phone1Text = contactTranslations['contact.phone.1'];
  const emailText = contactTranslations['contact.email.1'];
  const whatsappPhoneText = contactTranslations['contact.whatsapp'];
  const whatsappUrl = `https://wa.me/${whatsappPhoneText}?text=Hola%20me%20interesa%20tu%20servicio`;

  return (
    <div className={`fab-container ${isOpen ? 'abierto' : ''}`}>
      <div className="fab-opciones">
        <a 
          href={`tel:${phone1Text}`}
          className="fab-secundario"
          title={`Phone: ${phone1Text}`}
        >
          <i className="icono"><FaPhone /></i>
        </a>
        <a 
          href={whatsappUrl} 
          target="_blank" 
          rel="noopener noreferrer"
          className="fab-secundario"
          title={`WhatsApp: ${phone1Text}`}
        >
          <i className="icono"><FaWhatsapp /></i>
        </a>
        <a 
          href={`mailto:${emailText}`}
          className="fab-secundario"
          title={`Email: ${emailText}`}
        >
          <i className="icono"><FaEnvelope /></i>
        </a>
      </div>
      <div className="fab-principal" onClick={toggleFabMenu}>
        <i className="icono-principal"><FaComment /></i>
      </div>
    </div>
  );
};

export default FloatingActionButton;

